import { render, staticRenderFns } from "./BContentCard.vue?vue&type=template&id=05f9000f&scoped=true&"
import script from "./BContentCard.vue?vue&type=script&lang=js&"
export * from "./BContentCard.vue?vue&type=script&lang=js&"
import style0 from "./BContentCard.vue?vue&type=style&index=0&id=05f9000f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f9000f",
  null
  
)

export default component.exports